import PropTypes from 'prop-types'
import ActivityEmbeddedSitemodel from '../ActivityInput/ActivityEmbeddedSitemodel/ActivityEmbeddedSitemodel'

const SiteRenderer = ({ sitemodelUuid, urlSiteRenderer }) => {
  return (
    <ActivityEmbeddedSitemodel
      sitemodelUuid={sitemodelUuid}
      urlSiteRenderer={urlSiteRenderer}
    />
  )
}

SiteRenderer.propTypes = {
  sitemodelUuid: PropTypes.string.isRequired,
  urlSiteRenderer: PropTypes.string.isRequired
}

export default SiteRenderer
